import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { formatApiErrorDetail } from "@/lib/api";
import { Loader2 } from "lucide-react";
import { BrandLogo } from "@/components/BrandLogo";

export default function SignupPage() {
  const { signup } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ company_name: "", company_code: "", admin_name: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      await signup({ ...f, company_code: f.company_code.toUpperCase() });
      toast.success("Workspace created");
      nav("/dashboard");
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#FAF7EF] flex items-center justify-center p-6 bg-grain">
      <Card className="w-full max-w-lg border-[#E4DFCF] rounded-2xl shadow-lg">
        <CardHeader>
          <BrandLogo size={40} showWordmark tagline testId="signup-brand"/>
          <div className="font-serif text-3xl font-semibold mt-6">Create your workspace</div>
          <div className="text-sm text-[#4A5A50]">Set up your jewellery business in a minute.</div>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div><Label className="text-xs uppercase tracking-[0.2em] text-[#4A5A50]">Company Name</Label><Input data-testid="signup-company-name" value={f.company_name} onChange={(e)=>setF({...f, company_name:e.target.value})} required className="mt-1.5 rounded-lg"/></div>
              <div><Label className="text-xs uppercase tracking-[0.2em] text-[#4A5A50]">Company Code</Label><Input data-testid="signup-company-code" value={f.company_code} onChange={(e)=>setF({...f, company_code:e.target.value.toUpperCase()})} placeholder="e.g. STJ" required className="mt-1.5 rounded-lg"/></div>
            </div>
            <div><Label className="text-xs uppercase tracking-[0.2em] text-[#4A5A50]">Your Name</Label><Input data-testid="signup-admin-name" value={f.admin_name} onChange={(e)=>setF({...f, admin_name:e.target.value})} required className="mt-1.5 rounded-lg"/></div>
            <div><Label className="text-xs uppercase tracking-[0.2em] text-[#4A5A50]">Email</Label><Input type="email" data-testid="signup-email" value={f.email} onChange={(e)=>setF({...f, email:e.target.value})} required className="mt-1.5 rounded-lg"/></div>
            <div><Label className="text-xs uppercase tracking-[0.2em] text-[#4A5A50]">Password</Label><Input type="password" data-testid="signup-password" value={f.password} onChange={(e)=>setF({...f, password:e.target.value})} required minLength={6} className="mt-1.5 rounded-lg"/></div>
            {err && <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid="signup-error">{err}</div>}
            <Button type="submit" disabled={loading} className="w-full rounded-full bg-[#0F5E39] hover:bg-[#083F22] text-white h-11" data-testid="signup-submit">
              {loading ? <Loader2 className="animate-spin mr-2" size={16}/> : null}
              Create Workspace
            </Button>
            <div className="text-center text-sm text-[#4A5A50]">Have an account? <Link to="/login" className="text-[#0F5E39] hover:underline" data-testid="login-link">Sign in</Link></div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
